var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "product" }, [
    _vm.product.badge
      ? _c(
          "div",
          {
            staticClass: "add-badge",
            class: _vm.product.badge.text
              ? "blank"
              : _vm.product.badge.className,
          },
          [
            _vm.product.badge.text
              ? _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.product.badge.text) },
                })
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "product-header",
        class: { "left-align": _vm.product.headerLeftAlign },
      },
      [
        _c("p", [_vm._v(_vm._s(_vm.product.title))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.product.subtitle))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "product-body" },
      [
        _vm.product.price.original
          ? [
              _c("div", { staticClass: "break-line" }),
              _vm._v(" "),
              _c("p", { staticClass: "price original" }, [
                _vm._v(_vm._s(_vm.product.price.original)),
              ]),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "price discount" }, [
          _vm._v(_vm._s(_vm.product.price.discount)),
        ]),
        _vm._v(" "),
        _vm.product.bonusDesc || _vm.product.bonusDescHidden
          ? _c(
              "p",
              {
                staticClass: "price-desc new",
                class: { hide: _vm.product.bonusDescHidden },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.product.bonusDesc) +
                    "\n        "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.product.priceDesc
          ? _c("p", { staticClass: "price-desc" }, [
              _vm._v(
                "\n            " + _vm._s(_vm.product.priceDesc) + "\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.product.subDesc.text
          ? _c(
              "p",
              {
                staticClass: "price-desc sub",
                class: { color: _vm.product.subDesc.colored },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.product.subDesc.text) +
                    "\n        "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            on: {
              click: function ($event) {
                return _vm.$emit("purchase", _vm.product.link)
              },
            },
          },
          [_vm._v("立即购买")]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }